import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	roles: [],
};

// active account slice
export const allRolesSlice = createSlice({
	name: 'roles',
	initialState,
	reducers: {
		setAllRoles: (state, action) => {
			state.roles = action.payload;
		},
		setAllRolesList: (state, action) => {
			state.rolesList = action.payload;
		},
	},
});

export const {
	setAllRoles,
	setAllRolesList,
} = allRolesSlice.actions;

export default allRolesSlice.reducer;
